import { useEffect, useState } from "react";
import "./ToolBarProducts.scss";
import Trash from "../../icons/Trash";
import Download from "../../icons/Download";
import Bag from "../../icons/Bag";
import Folder from "../../icons/Folder";
import MooveTool from "../../icons/MooveTool";
import { motion } from "framer-motion";
import { useSelector, useDispatch, RootStateOrAny } from "react-redux";
import { handleBottomAddToCollection } from "../../actions/actionCreators";
import {
  archiveFolder,
  clearSelectedFolders,
  clearSelectedProducts,
  deleteProductsfromFolder,
  handleMovingState,
  handleMovingStateProduct,
  handleMovingStateProducts,
} from "../../actions/folders-actions/actions";
import { Popconfirm, message } from "antd";
import { addProdDemcoToOrder } from "../../actions/order-actions/actions";
import { Spin, Drawer } from "antd";
import order_sent from "../../img/order_sent.jpg";
import { LoadingOutlined } from "@ant-design/icons";

export interface IToolBarProductsProps {
  setProductsToOrder: (p: any) => void;
  productsToOrder: any;
}

export default function ToolBarProducts({
  setProductsToOrder,
  productsToOrder,
}: IToolBarProductsProps) {
  const dispatch = useDispatch();
  const [width, setWidth] = useState(window.innerWidth);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [name, setName] = useState("");
  const [folderId, setfolderId] = useState("");
  const [folder, setfolder] = useState<any>("folder");
  const [subfolders, setsubfolders] = useState<any>([]);

  const folders = useSelector((state: RootStateOrAny) => state.folders);
  const sortedFolders = useSelector(
    (state: RootStateOrAny) => state.folders.sortedFolders
  );
  const variants = {
    enter: { opacity: 0 },
    center: { opacity: 1 },
    exit: { opacity: 0 },
  };
  useEffect(() => {
    const resize: any = window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [width]);

  useEffect(() => {
    if (folders.oneFolder) {
      setfolder(folders.oneFolder);
      setName(folders.oneFolder.name);
    } else {
      setName(folders.oneFolder.name);
      setfolderId(folders.oneFolder.id);
    }

    setsubfolders(
      folders.folders.filter((el: any) => el.parent_id === folders.oneFolder.id)
    );
  }, []);

  const { addDemcoProductOrderLoading } = useSelector(
    (state: any) => state.orders
  );
  const substructSubProducts = (folder: any, products: any) => {
    console.log("folder: ", folder);
    if (folder && folder.products) {
      products.push(folder.products);
    }

    if (folder && folder.folders && folder.folders.length > 0) {
      folder.folders.forEach((_folder: any) => {
        substructSubProducts(_folder, products);
      });
    }
    console.log(products);
    return;
    // return folders;
  };
  const sendOrder = () => {
    const folderId = folders.oneFolder.id;
    let arr: any = [];
    const selectedFolderFromSortedFolders = sortedFolders.find(
      (el: any) => el.id === folderId
    );
    substructSubProducts(selectedFolderFromSortedFolders, arr);

    dispatch(
      addProdDemcoToOrder(
        productsToOrder.map((el: any) => {
          return {
            ...el,
            qty: 0,
          };
        }),
        /*  arr.flat().map((el: any) => {
          return {
            ...el,
            qty: 0,
          };
        }), */
        false,
        name
      )
    );

    setIsOpenDrawer(true);
    setTimeout(() => {
      setIsOpenDrawer(false);
      dispatch(clearSelectedProducts());
    }, 2000);
  };

  return (
    <motion.div
      transition={{ type: "tween" }}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      className="tool_bar_container"
    >
      <div className="left_side">
        <p>
          <span>({folders.selectedProducts.length})</span>{" "}
          {width > 768 && "Products selected"}
        </p>
      </div>
      <div className="right_side">
        {/* <div className="functionality_container">
         
          <p className="functionality_text">Unselect</p>
        </div> */}
        <div
          className="functionality_container"
          onClick={() => {
            dispatch(handleBottomAddToCollection());
            dispatch(handleMovingStateProducts());
          }}
        >
          <MooveTool />
          {width > 1024 && <p className="functionality_text">Move to</p>}
        </div>
        {/* <div className="functionality_container">
          <Download />
          {width > 1024 && <p className="functionality_text">Download</p>}
        </div> */}
        <Popconfirm
          title="Are you sure you want to order the selected products?"
          onConfirm={sendOrder}
          onCancel={() => {}}
          okText="Yes"
          cancelText="No"
        >
          <div
            className="functionality_container"
            // onClick={() => {
            //   sendOrder();
            // }}
          >
            {addDemcoProductOrderLoading ? (
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            ) : (
              <>
                <Bag />
                {width > 1024 && <p className="functionality_text">Order</p>}
              </>
            )}
          </div>
        </Popconfirm>
        <Popconfirm
          placement="topRight"
          title="Are you sure to delete the selected products?"
          onConfirm={() => {
            var idsProducts = folders.selectedProducts.map((item: any) => {
              return item["id"];
            });
            folders.selectedProducts.length > 0 &&
              dispatch(
                deleteProductsfromFolder(
                  idsProducts,
                  folders.selectedProducts[0].idParentFolder
                )
              );
            dispatch(clearSelectedProducts());
          }}
          onCancel={() => {}}
          okText="Yes"
          cancelText="No"
        >
          <div className="functionality_container">
            <Trash />
            {width > 1024 && <p className="functionality_text">Delete</p>}
          </div>
        </Popconfirm>
      </div>
      <Drawer
        className="order_sent_drawer"
        placement={"bottom"}
        closable={true}
        onClose={() => {
          setIsOpenDrawer(false);
        }}
        visible={isOpenDrawer}
        key={"bottom"}
      >
        <div className="my-2">
          <h1>Your order has been sent</h1>
          <p>
            We will train you in the coming days on the advancement of your
            product.{" "}
          </p>
        </div>
        <img src={order_sent} alt="order sent" className="img-fluid my-2" />
      </Drawer>
    </motion.div>
  );
}
